export default "__VITE_ASSET__CcGg0ZDz__"